import {lazyWithRetry} from '../../libs/ui/src';

export const NotFoundPage = lazyWithRetry(() => import('./NotFound'));
